"use client";
import { createContext, useContext, useState } from "react";

export const EventContext = createContext({
  eventFilters: {
    date: "",
    service: 0 | 1,
  },
  clearFilters: () => {},
  setEventFilters: (ev: any) => {},
});

export const EventProvider = ({ children }: any) => {
  const [eventFilters, setEventFilters] = useState({} as any);

  const clearFilters = () => {
    setEventFilters({
      date: undefined,
      service: undefined,
    });
  };

  const value = {
    eventFilters,
    setEventFilters,
    clearFilters,
  };

  return (
    <EventContext.Provider value={value}>{children}</EventContext.Provider>
  );
};

export const useEventContext = () => {
  return useContext(EventContext);
};
